import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { capitalize, head, startCase } from 'lodash';
import { aclHelper, usePersistState } from 'helper';
import List from 'partial/components/List';
import SearchBar from 'partial/components/input/SearchBar';
import Card from 'partial/components/Card';
import Button from 'partial/components/Button';
import { useCategoryList } from './hooks';
import { useOpenCategorySetup } from './modals/CategorySetup';
import ContentDetails from './containers/ContentDetails';

function ContentManagement() {
  const [isLoading, list] = useCategoryList({});
  const openSetup = useOpenCategorySetup();
  const navigate = useNavigate();

  const [selected, setSelected] = usePersistState('category-id', '', {
    keepOnUnmount: false,
  });
  const [filter, setFilter] = useState({
    keyword: '',
  });

  const onSubSelect = (item) => {
    setSelected(item.id);
    navigate(`${item.id}`);
  };

  useEffect(() => {
    if (selected || list?.length === 0) return;
    setSelected(head(list)?.id);
  }, [list, selected, setSelected]);

  return (
    <Card>
      <section className="flex p-6 bg-white drop-shadow rounded-lg flex-grow static min-h-[calc(100vh_-_12rem)]">
        <div className="pr-4 border-r border-gray-50 min-w-[260px] flex flex-col">
          <SearchBar
            name="keyword"
            value={filter.keyword}
            onChange={setFilter}
            inputClassName="py-[1.05rem] !w-full"
            containerClassName="mb-4"
          />
          <List
            data={list}
            isLoading={isLoading}
            selectedId={selected}
            onSelectRow={onSubSelect}
            render={(item) => (
              <div className="flex items-center gap-2 pl-2 py-[0.65rem]">
                <span className="text-xs font-light">
                  {startCase(capitalize(item?.name))}
                </span>
              </div>
            )}
            selectedKey="id"
            containerClassName="!w-60"
          />
          {aclHelper(
            'cms',
            'w',
            <Button
              onClick={() => openSetup({})}
              primary
              className="uppercase"
              size="sm"
            >
              add category
            </Button>,
          )}
        </div>

        <Routes>
          <Route path=":categoryId/*" element={<ContentDetails />} />

          {list?.length > 0 && (
            <Route
              index
              element={<Navigate replace to={`${head(list)?.id}`} />}
            />
          )}
        </Routes>
      </section>
    </Card>
  );
}

export default ContentManagement;
